var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0345 17.5874C5.46512 17.5874 1.74487 13.8672 1.74487 9.29773C1.74487 4.7283 5.46512 1.00806 10.0345 1.00806C14.604 1.00806 18.3242 4.7283 18.3242 9.29773C18.3242 13.8672 14.604 17.5874 10.0345 17.5874ZM10.0345 2.22118C6.12829 2.22118 2.958 5.39956 2.958 9.29773C2.958 13.1959 6.12829 16.3743 10.0345 16.3743C13.9408 16.3743 17.1111 13.1959 17.1111 9.29773C17.1111 5.39956 13.9408 2.22118 10.0345 2.22118Z",
    fill: "#898989"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5265 18.396C18.3728 18.396 18.2192 18.3394 18.0978 18.2181L16.4803 16.6006C16.2458 16.366 16.2458 15.9778 16.4803 15.7433C16.7149 15.5087 17.1031 15.5087 17.3376 15.7433L18.9551 17.3608C19.1897 17.5953 19.1897 17.9835 18.9551 18.2181C18.8338 18.3394 18.6801 18.396 18.5265 18.396Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.f2eaef816c22d055d96128aa7bf815ef.svg";
export { ForwardRef as ReactComponent };